module.exports = __webpack_public_path__ + "img/heroes_score_bg01.5dc38237.png";